import {Component, forwardRef, inject} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {PageTitleComponent} from '../../../shared/commons/page-title/page-title.component';
import {AddBusinessFormData, BusinessType} from './add-business-form-data';
import {BUSINESS_FORM} from './business-form.token';
import {BusinessFormCardComponent} from './business-form-card/business-form-card.component';
import {UserBusinessDto} from '../../../../models/generated-models';

@Component({
  selector: 'app-add-business-page',
  imports: [
    CommonModule,
    FormsModule,
    PageTitleComponent,
    BusinessFormCardComponent
  ],
  providers: [{provide: BUSINESS_FORM, useExisting: forwardRef(() => AddBusinessPage)}],
  templateUrl: './add-business-page.html',
  styleUrl: './add-business-page.scss'
})
export class AddBusinessPage extends AddBusinessFormData {
  private readonly location = inject(Location);
  private readonly router = inject(Router);

  constructor() {
    super();
    const state = (history.state ?? {}) as Record<string, any>;
    this.editMode = state['editMode'] === true;
    this.initialBusiness = state['business'] ?? null;
    const stateType = state['businessType'] as BusinessType | undefined;
    if (stateType === 'company' || stateType === 'cooperative' || stateType === 'individual') {
      this.setBusinessType(stateType);
    }
  }

  cancel(): void {
    this.location.back();
  }

  protected handleSubmitSuccess(_saved: UserBusinessDto): void {
    this.toast.success(this.editMode ? 'แก้ไขข้อมูลธุรกิจเรียบร้อยแล้ว' : 'บันทึกข้อมูลธุรกิจเรียบร้อยแล้ว');
    void this.router.navigateByUrl('/profile/business');
  }
}
